import React from 'react';
import { connect } from 'react-redux';
import AgendaPreview from './AgendaPreview';
import AnnouncementPreview from './AnnouncementPreview';
import PinnedPreview from './PinnedPreview';
import SocialPreview from './SocialPreview';
import ButtonPreview from './ButtonPreview';
import MediaPreview from './MediaPreview';
import DividerPreview from './DividerPreview';
import './index.scss';
import SpacerPreview from './SpacerPreview';
import TextPreview from './TextPreview';
import HeaderPreview from './HeaderPreview';
import IconPreview from './IconPreview';

const WidgetPreviews = props => {
	const { currentEvent, item, style, deviceWidth, type, from } = props;
	const { props: widgetProps = {} } = item || {};

	const theme = currentEvent ? currentEvent.theme : {};
	const { brandPrimary, brandSecondary } = theme;
	const isWeb = deviceWidth >= 820;
	const isPad = !isWeb && deviceWidth >= 530;

	const fromButton = from === 'WidgetButton';
	const fromPreview = from === 'Preview';
	const fromStandardHomescreen = from === 'nativeLayoutHelpers';
	const includeHeaders = widgetProps.include_headers;

	const accentColor = fromButton ? '#757575' : (style && style.color) || brandPrimary || '#00000';

	const padding = from ? '1em' : isPad ? '1.5em 2em 1em 2em' : '1.5em 1.5em 1em 1.5em';
	const margin = fromButton || fromStandardHomescreen ? 0 : fromPreview ? '6px 8px' : '.5rem';

	switch (type || (item && item.props.type)) {
		case 'Announcements':
			return (
				<AnnouncementPreview
					color={accentColor}
					isPad={isPad}
					from={from}
					padding={padding}
					margin={margin}
					includeHeaders={includeHeaders}
				/>
			);
		case 'Pinned':
			return (
				<PinnedPreview
					color={accentColor}
					isPad={isPad}
					from={from}
					padding={padding}
					margin={margin}
					includeHeaders={includeHeaders}
				/>
			);
		case 'Social':
		case 'Social Feed':
			return (
				<SocialPreview
					display={(item && item.props.display) || 'standard'}
					color={accentColor}
					isPad={isPad}
					isWeb={isWeb}
					from={from}
					padding={padding}
					margin={margin}
					includeHeaders={includeHeaders}
				/>
			);
		case 'Agenda':
			return (
				<AgendaPreview
					color={accentColor}
					isPad={isPad}
					from={from}
					margin={margin}
					includeHeaders={includeHeaders}
					accentColor={fromButton ? accentColor : brandSecondary}
				/>
			);
		case 'Media':
			return <MediaPreview from={from} margin={margin} media={item} style={style} />;
		case 'Button':
			return <ButtonPreview from={from} margin={margin} button={item} style={style} />;
		case 'Divider':
			return <DividerPreview from={from} divider={item} style={style} />;
		case 'Spacer':
			return <SpacerPreview from={from} style={style} />;
		case 'Text':
			return <TextPreview from={from} style={style} item={item} margin={margin} />;
		case 'Header':
			return <HeaderPreview from={from} header={item} />;
		case 'Icon':
			return <IconPreview from={from} icon={item} />;
		default:
			return null;
	}
};

const msp = ({ events }) => ({
	currentEvent: events.currentEvent,
});

export default connect(msp, null)(WidgetPreviews);
